module.exports = __webpack_public_path__ + "img/avatar7.e15b8e9a.png";